module.exports = __webpack_public_path__ + "img/header.5801f2ce.png";